import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import React from 'react';
import { UpdateAccountInfo } from './update-account-info';
import { appConfig } from 'config';
import './update-account-info-page.css';
const stripePromise = loadStripe(appConfig.stripePk);
export const UpdateAccountInfoPage = () => {
    return (React.createElement("div", { className: "full-page" },
        React.createElement(Elements, { stripe: stripePromise },
            React.createElement(UpdateAccountInfo, null))));
};
